import { useEffect } from 'react';
/**
 * Sets `max-height` on the referenced element so its bottom edge sits at the bottom of the
 * viewport, regardless of how far the page is scrolled. Re-measures on scroll and resize.
 * Useful for sticky side-panels
 */
export var useFitToViewportBottom = function (ref, enabled) {
    useEffect(function () {
        if (!enabled)
            return undefined;
        var el = ref.current;
        if (!el)
            return undefined;
        var frame = 0;
        var update = function () {
            var rect = el.getBoundingClientRect();
            var available = Math.max(0, window.innerHeight - rect.top);
            el.style.maxHeight = "".concat(available, "px");
        };
        var schedule = function () {
            if (frame)
                return;
            frame = window.requestAnimationFrame(function () {
                frame = 0;
                update();
            });
        };
        update();
        window.addEventListener('scroll', schedule, { passive: true });
        window.addEventListener('resize', schedule);
        return function () {
            if (frame)
                window.cancelAnimationFrame(frame);
            window.removeEventListener('scroll', schedule);
            window.removeEventListener('resize', schedule);
        };
    }, [ref, enabled]);
};
